// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/—Pngtree—gradient wave lines vector_7931546 (1).png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.dark-mode .about-section {
  background-color: rgba(0, 0, 0, 0.2);
}

.about-section {
  display: flex;
  gap: 30px;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  padding: 0px 30%;
  min-height: 700px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: cover;
  background-attachment: fixed;
  background-position: center;
}

.about-section .content {
  text-align: left;
  z-index: 2;
}
.about-section .content .social_icons {
  display: flex;
  flex-direction: row;
  gap: 10px;
  color: white;
}
.about-section .content .social_icons svg {
  font-size: 1.8em;
}
.about-section .content .mobile_social_icons {
  display: none;
}
.about-section .content p {
  font-size: 1.5em;
  margin-block-start: 0px;
  margin-block-end: 0px;
}
.about-section .content h1 {
  font-size: 5em;
  margin-block-start: 0px;
  margin-block-end: 0px;
}

.about-section .image-wrapper {
  z-index: 2;
}
.about-section .image-wrapper img {
  width: 200px;
  border-radius: 10%;
}

.about p {
  text-align: center;
  padding-top: 10%;
  padding-bottom: 10%;
}

@media screen and (max-width: 567px) {
  .nav-left {
    padding-top: 20px;
    float: left;
  }
  .nav-left img {
    height: 35px;
  }
  .nav-right {
    float: right;
  }
  .nav-right li {
    padding: 10px 15px;
    list-style: none;
    font-size: 13px;
    color: white;
    width: 10%;
  }
  .nav-right ul {
    list-style-type: none;
    margin: 0px;
    padding: 0px;
  }
  body {
    width: 100%;
  }
  .about {
    padding-left: 5%;
    padding-right: 5%;
    font-size: 12px;
  }
}
@media screen and (max-width: 768px) {
  .about-section h1 {
    font-size: 4em !important;
    text-align: left;
  }
  .about-section p {
    text-align: left;
  }
  .container {
    display: initial;
  }
  .social_icons {
    display: none !important;
  }
  .mobile_social_icons {
    padding-top: 10px;
    display: flex !important;
    flex-direction: row;
    gap: 10px;
    color: white;
  }
  .mobile_social_icons svg {
    font-size: 1.8em;
  }
  .about-section {
    padding-top: 150px;
    display: block;
    padding-left: 0px;
    padding-right: 0px;
  }
  .about-section .content {
    width: 90%;
    padding-left: 5%;
    padding-right: 5%;
    padding-bottom: 5%;
  }
  .about-section .image-wrapper {
    padding-left: 0%;
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/Main.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACI,oCAAA;AAEJ;;AACA;EACI,aAAA;EACA,SAAA;EACA,2BAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,yDAAA;EACA,4BAAA;EACA,sBAAA;EACA,4BAAA;EACA,2BAAA;AAEJ;;AACA;EACI,gBAAA;EACA,UAAA;AAEJ;AAAI;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;AAER;AAAQ;EACI,gBAAA;AAEZ;AAEI;EACI,aAAA;AAAR;AAGI;EACI,gBAAA;EACA,uBAAA;EACA,qBAAA;AADR;AAII;EACI,cAAA;EACA,uBAAA;EACA,qBAAA;AAFR;;AAMA;EACI,UAAA;AAHJ;AAII;EACI,YAAA;EACA,kBAAA;AAFR;;AAMA;EACI,kBAAA;EACA,gBAAA;EACA,mBAAA;AAHJ;;AAOI;EACI;IACI,iBAAA;IACA,WAAA;EAJV;EAOM;IACI,YAAA;EALV;EAQM;IACI,YAAA;EANV;EASM;IACI,kBAAA;IACA,gBAAA;IACA,eAAA;IACA,YAAA;IACA,UAAA;EAPV;EAUM;IACI,qBAAA;IACA,WAAA;IACA,YAAA;EARV;EAWM;IACI,WAAA;EATV;EAYM;IACI,gBAAA;IACA,iBAAA;IACA,eAAA;EAVV;AACF;AAaI;EACI;IACI,yBAAA;IACA,gBAAA;EAXV;EAcM;IACI,gBAAA;EAZV;EAeM;IACI,gBAAA;EAbV;EAgBM;IACI,wBAAA;EAdV;EAiBM;IACI,iBAAA;IACA,wBAAA;IACA,mBAAA;IACA,SAAA;IACA,YAAA;EAfV;EAiBU;IACI,gBAAA;EAfd;EAmBM;IACI,kBAAA;IACA,cAAA;IACA,iBAAA;IACA,kBAAA;EAjBV;EAoBM;IACI,UAAA;IACA,gBAAA;IACA,iBAAA;IACA,kBAAA;EAlBV;EAqBM;IACI,gBAAA;IACA,WAAA;EAnBV;AACF","sourcesContent":[".dark-mode .about-section {\n    background-color: rgba(0, 0, 0, 0.2);\n}\n\n.about-section {\n    display: flex;\n    gap: 30px;\n    justify-content: flex-start;\n    align-items: center;\n    width: 100%;\n    padding: 0px 30%;\n    min-height: 700px;\n    background-image: url(\"../images/—Pngtree—gradient wave lines vector_7931546 (1).png\");\n    background-repeat: no-repeat;\n    background-size: cover;\n    background-attachment: fixed;\n    background-position: center;\n}\n\n.about-section .content {\n    text-align: left;\n    z-index: 2;\n\n    .social_icons {\n        display: flex;\n        flex-direction: row;\n        gap: 10px;\n        color: white;\n\n        svg {\n            font-size: 1.8em;\n        }\n    }\n\n    .mobile_social_icons {\n        display: none;\n    }\n\n    p {\n        font-size: 1.5em;\n        margin-block-start: 0px;\n        margin-block-end: 0px;\n    }\n\n    h1 {\n        font-size: 5em;\n        margin-block-start: 0px;\n        margin-block-end: 0px;\n    }\n}\n\n.about-section .image-wrapper {\n    z-index: 2;\n    img {\n        width: 200px;\n        border-radius: 10%;\n    }\n}\n\n.about p {\n    text-align: center;\n    padding-top: 10%;\n    padding-bottom: 10%;\n}\n\n@media screen {\n    @media (max-width: 567px) {\n        .nav-left{\n            padding-top: 20px;\n            float:left;\n        }\n\n        .nav-left img {\n            height: 35px\n        }\n\n        .nav-right {\n            float:right;\n        }\n\n        .nav-right li {\n            padding: 10px 15px;\n            list-style:none;\n            font-size:13px;\n            color:white;\n            width: 10%;\n        }\n\n        .nav-right ul {\n            list-style-type: none;\n            margin: 0px;\n            padding: 0px;\n        }\n\n        body {\n            width: 100%;\n        }\n\n        .about {\n            padding-left: 5%;\n            padding-right: 5%;\n            font-size: 12px;\n        }\n    }\n\n    @media (max-width:768px) {\n        .about-section h1 {\n            font-size: 4em !important;\n            text-align: left;\n        }\n\n        .about-section p {\n            text-align: left;\n        }\n\n        .container {\n            display: initial;\n        }\n\n        .social_icons {\n            display: none !important;\n        }\n\n        .mobile_social_icons {\n            padding-top: 10px;\n            display: flex !important;\n            flex-direction: row;\n            gap: 10px;\n            color: white;\n    \n            svg {\n                font-size: 1.8em;\n            }\n        }\n\n        .about-section {\n            padding-top: 150px;\n            display: block;\n            padding-left: 0px;\n            padding-right: 0px;\n        }\n\n        .about-section .content {\n            width: 90%;\n            padding-left: 5%;\n            padding-right: 5%;\n            padding-bottom: 5%;\n        }\n\n        .about-section .image-wrapper {\n            padding-left: 0%;\n            width: 100%;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
